import React, { useEffect, useState } from 'react';
import { BiErrorCircle } from 'react-icons/bi';
import { useDispatch } from 'react-redux';
import { Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { RETRIEVE_SPECIFIC_GRN_SCHEDULER_CONSIGNMENT_DETAILS_API } from '../../../../api/api_data';
import { employee_dashboard_actions_helper } from '../../../../actions/actions_helper';
import { fail_retrieve_specific_grn_schedule_consigment_details, loading_retrieve_specific_grn_schedule_consigment_details, reset_retrieve_specific_grn_schedule_consigment_details, success_retrieve_specific_grn_schedule_consigment_details } from '../../../../reducers/dashboard_reducers/warehouse/retrieve_specific_grn_schedule_consigment_details_Slice';
import * as app_consts from "../../../../constants/react_app_consts";
import { RETRIEVE_SPECIFIC_GRN_SCHEDULE_CONSIGNMENT_DETAILS_ACCESS_DENIED_MSG, RETRIEVE_SPECIFIC_GRN_SCHEDULE_CONSIGNMENT_DETAILS_ERR_MSG, RETRIEVE_SPECIFIC_GRN_SCHEDULE_CONSIGNMENT_DETAILS_SUCCESS_MSG } from '../../../../constants/success_error_messages_consts';
import { useSelector } from 'react-redux';
import { messageToast } from '../../../../utils/Utils';
import CardTabs from '../cards/CardTabs';
import { BlockHead, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon } from '../../../../components/Component';
import ProfileDetailText from '../text/ProfileDetailText';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { addThreeDots } from '../../../../utils/functionalUtils';

const tabs = [
  {
    tabName: "Main Info"
  },
  {
    tabName: "History"
  }, ,
  {
    tabName: "GRN Details"
  }, ,
  {
    tabName: "Delivery Note"
  },
];

const ViewSpecificGRNScheduleDetails = ({ isOpen, closeModal, data }) => {

  const [page_data, setPageData] = useState([]);
  const [open, setOpen] = useState(isOpen);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const [sent_id, setSentID] = useState(data);
  const [activeCardTab, setActiveCardTab] = useState("Main Info");

  useEffect(() => {
    setOpen(isOpen);
    if (isOpen)
    {
      retrieve_grn_schedule_consignment_details(data);
      setSentID(data);
    }
  }, [isOpen, data]);

  // Retrieve Consignment Details
  const retrieve_grn_schedule_consignment_details = (grn_schedule_id) => {
    setError("");
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_specific_grn_schedule_consigment_details,
        success_retrieve_specific_grn_schedule_consigment_details,
        fail_retrieve_specific_grn_schedule_consigment_details,
        RETRIEVE_SPECIFIC_GRN_SCHEDULE_CONSIGNMENT_DETAILS_ERR_MSG,
        RETRIEVE_SPECIFIC_GRN_SCHEDULE_CONSIGNMENT_DETAILS_SUCCESS_MSG,
        app_consts.GET,
        `${RETRIEVE_SPECIFIC_GRN_SCHEDULER_CONSIGNMENT_DETAILS_API}${grn_schedule_id}`,
        null,
        RETRIEVE_SPECIFIC_GRN_SCHEDULE_CONSIGNMENT_DETAILS_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Reducer
  const retrieve_specific_grn_schedule_consigment_details_listener = useSelector((state) => state.retrieve_specific_grn_schedule_consigment_details.retrieve_specific_grn_schedule_consigment_details);
  // 
  useEffect(() => {
    if (retrieve_specific_grn_schedule_consigment_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_specific_grn_schedule_consigment_details_listener.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (retrieve_specific_grn_schedule_consigment_details_listener.status === app_consts.FAIL)
        {
          setError(retrieve_specific_grn_schedule_consigment_details_listener.message);
          messageToast(retrieve_specific_grn_schedule_consigment_details_listener.message, app_consts.FAIL);
        } else if (retrieve_specific_grn_schedule_consigment_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_specific_grn_schedule_consigment_details_listener.data);
        }
        dispatch(reset_retrieve_specific_grn_schedule_consigment_details());
      }
    }
  }, [retrieve_specific_grn_schedule_consigment_details_listener]);

  return (
    <>
      <Modal isOpen={open} toggle={closeModal} className="modal-dialog-centered" size={"xl"}>
        <ModalHeader toggle={closeModal}>GRN Schedule Consignment Details</ModalHeader>
        <ModalBody>
          {
            loading ?
              <>
                <div className='p-5 d-flex align-center justify-center'>
                  <Spinner />
                </div>
              </>
              :
              <>
                {
                  error && error.length > 0 ?
                    <>
                      <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                        <BiErrorCircle className="text-danger fs-3" />
                        <p>{error}</p>
                      </div>
                    </>
                    :
                    <>

                      <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                      <div className="card-inner">
                        {
                          activeCardTab === "Main Info" && (
                            <>
                              <BlockHead>
                                <BlockTitle tag="h6">Main Info</BlockTitle>
                              </BlockHead>
                              <div className="profile-ud-list">
                                <ProfileDetailText label="Name" text={page_data?.name || "---"} />
                                <ProfileDetailText label="Horse Reg No" text={page_data?.horse_reg || "---"} />
                                <ProfileDetailText label="Trailer Reg No 1" text={page_data?.trailer_reg_one || "---"} />
                                <ProfileDetailText label="Trailer Reg No 2" text={page_data?.trailer_reg_two || "---"} />
                                <ProfileDetailText label="Driver" text={page_data?.driver || "---"} />
                                <ProfileDetailText label="Transporter" text={page_data?.transporter || "---"} />
                                <ProfileDetailText label="Tonnage" text={page_data?.tonnage || "0.00"} />
                                <ProfileDetailText label="Quantity Offloaded" text={page_data?.quantity_offloaded || "0.00"} />
                                <ProfileDetailText label="Cargo Details" text={page_data?.cargo_details || "---"} />
                                <ProfileDetailText label="Offload Point" text={page_data?.offload_point || "---"} />
                                <ProfileDetailText label="Date Loaded" text={page_data?.data_loaded || "---"} />
                                <ProfileDetailText label="Load Reference" text={page_data?.load_reference || "---"} />
                                <ProfileDetailText label="Created On" text={page_data?.inserted_at ? moment(page_data?.inserted_at).format("MMMM Do, YYYY") : "---"} />
                                <ProfileDetailText label="Status" text={page_data?.status || "---"} />
                              </div>
                            </>
                          )
                        }
                        {
                          activeCardTab === "History" && (
                            <>
                              <BlockHead>
                                <BlockTitle tag="h6">History</BlockTitle>
                              </BlockHead>
                              <div className="nk-tb-list is-separate is-medium mb-3">
                                <DataTableHead className="nk-tb-item">
                                  <DataTableRow>
                                    <span className="sub-text">Message</span>
                                  </DataTableRow>
                                  <DataTableRow size="lg">
                                    <span className="sub-text">Timestamp</span>
                                  </DataTableRow>
                                  <DataTableRow size="md">
                                    <span className="sub-text">Action</span>
                                  </DataTableRow>
                                </DataTableHead>
                                {page_data?.history?.length > 0
                                  ? page_data?.history?.map((item) => (
                                    <DataTableItem key={item.timestamp}>
                                      <DataTableRow>
                                        <span className="tb-sub">{item?.message ? addThreeDots(item?.message, 60) : "--"}</span>
                                      </DataTableRow>
                                      <DataTableRow>
                                        <span className="tb-product">
                                          <span className="tb-sub">{item?.timestamp ? moment(item?.timestamp).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                        </span>
                                      </DataTableRow>
                                      <DataTableRow className="nk-tb-col-tools">
                                        <div className="tb-odr-btns d-none d-sm-inline">
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </div>
                                        <Button className="btn-pd-auto d-sm-none">
                                          <Icon name="chevron-right"></Icon>
                                        </Button>
                                      </DataTableRow>
                                    </DataTableItem>
                                  ))
                                  : null}
                              </div>
                            </>
                          )
                        }
                      </div>
                    </>
                }
              </>
          }
        </ModalBody>
      </Modal>
    </>
  );
};

export default ViewSpecificGRNScheduleDetails;